import { element } from 'protractor';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Router} from '@angular/router'
import { EmployeeOrderEditComponent } from '../employee-order-edit/employee-order-edit.component';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';

@Component({
  selector: 'app-new-employee-order',
  templateUrl: './new-employee-order.component.html',
  styleUrls: ['./new-employee-order.component.scss']
})
export class NewEmployeeOrderComponent implements OnInit {

  title:any;
  employee_list:any;
  search_term: any;
  filtered_employee_list: any;
  final_employee_list = [];
  today_date: any;
  month: any;
  year: any;
  this_order_is_placed = null;
  employee_order_list = [];
  is_disabled = false;
  is_loaded = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  element_already_present:any = null;
  element_have_null_field:any = null;
  next_month: any;
  next_year: any;
  monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];

  constructor(private http: HttpService, private router: Router, private dialog: MatDialog) {
    this.http.getEmployeeList().subscribe((data) => {
      this.employee_list = data;
    });
    this.getCurrentDate();
  }

  searchEmployeeCalled(search_term) {
    console.log(search_term);
    if (this.search_term == null || this.search_term === '') {
      this.filtered_employee_list = [];
    } else {
      this.filtered_employee_list = this.employee_list.filter((element) => {
        return element.employee_name.toLowerCase().indexOf(search_term.toLowerCase()) > -1 || element.employee_code.toLowerCase().indexOf(search_term.toLowerCase()) > -1;
      });
    }
  }

  selectEmployeeCode(employee_code) {
    console.log(employee_code);
    let data_dict = {
      'employee_code': employee_code,
      'month': this.month,
      'year': this.year
    }
    this.http.placeNewOrderForEmployee(data_dict).subscribe((data) => {
      console.log(data);
      this.this_order_is_placed = data['order_status'];
      if (this.this_order_is_placed == true) {
        alert(data['data']);
        this.this_order_is_placed = false;
        this.search_term = null;
      } else {
        this.element_already_present =  this.employee_order_list.find(ob => ob.employee_code === data['data'][0].employee_code)
        console.log(this.element_already_present)
        if (this.element_already_present == null) {
          this.employee_order_list.push(data['data'][0]);
          this.element_already_present = null;
        }
        else {
          alert('Employee already added...!')
          this.element_already_present = null;
        }
        this.search_term = null;
      }
    });
    console.log(this.employee_order_list);
  }

  openDialog(edit_field, index, employee_order): void {
    console.log('dialog open');
    const dialogRef = this.dialog.open(EmployeeOrderEditComponent, {
      height: '250px',
      width: '665px',
      data: {
        'input': edit_field,
        'employee_order': employee_order,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      this.employee_order_list[index][edit_field] = res['value'];
      console.log(this.employee_order_list[index])
    });
  }

  removeItem(index){
    this.employee_order_list.splice(index, 1);
  }

  orderClicked() {
    this.element_have_null_field =  this.employee_order_list.find(ob => ob.product === null)
    if(this.element_have_null_field != null){
      this.is_loaded = true;
      alert("Product field is not filled !!!");
    } else{
      if(confirm('Are you sure to order ?')){
        this.is_loaded = false;
        this.is_disabled = true;
        let data_dict = {
          'customer_type_id': this.employee_order_list[0]['customer_type'],
          'employee_order_list': this.employee_order_list
        }
        this.http.placeEmployeeOrder(data_dict).subscribe((data) => {
          if(data == true){
            this.is_loaded = true;
            alert("Order Successfuly Placed");
            this.employee_order_list = [];
            this.router.navigate(['/new/employee/order']);
          }
        }, (error) => {
          return "Some error occured";
        });
      }
    }
  }

  async getCurrentDate() {
    this.today_date = await this.http.getCurrentDate();
    this.month = new Date(this.today_date).getMonth() + 1;
    this.year = new Date(this.today_date).getFullYear();
    if(this.month != 12) {
      this.next_month = this.month;
      this.next_year = this.year
    }
    else {
      this.next_month = 1;
      this.next_year = this.year +1;
    }
    console.log(this.month);
  }

  customerRegister() {
    this.router.navigate(['/icustomer/table']);
  }

  ngOnInit() {
  }

}
